<template>
  <div>
    <Overlay v-if="cargando" />
    <div class="bus">
      <div
        class="container-fluid"
        v-if="$route.params.ciudad === 'juarez'"
      >
        <div class="row justify-content-center pt-4 mb-2">
          <img
            :src="bus.metadata.image.url"
            :alt="bus.nombre"
            class="imagen-banner"
          >
        </div>
        <div class="row mt-2">
          <h2 class="titulo-lugar-juarez">{{bus.nombre}}</h2>
        </div>
        <!-- <div class="row mb-2">
          <span>{{lugar.descripcion.type}}</span>
        </div> -->
        <div class="row mb-4">
          <div class="col-12">
            <span v-html="bus.metadata.descripcion"></span>
            <div class="row">
              <h3 class="titulo-lugar-juarez">Recorrido:</h3>
            </div>
            <div
              class="row"
              v-for="(punto, key) in puntos"
              :key="key"
            >
              <span>{{key + 1}}</span>
              <span class="bold">{{punto}}</span>
            </div>
            <div class="row">
              <h3 class="titulo-lugar-juarez">Horario: </h3> <br>
            </div>
            <div class="row">
              <span>{{bus.metadata.horario}}</span>
            </div>
            <div class="row">
              <div class="col-12 mapa">
                <!-- <h2>Ruta</h2> -->
                <img
                  :src="'https://maps.googleapis.com/maps/api/staticmap?scale=2&size=520x300&maptype=roadmap&key=AIzaSyC6gpvlCJsWzDkVYD--fvIzikiclJPk2Ng&format=png&visual_refresh=true'+markers+'&path=weight:4%7Ccolor:green%7Cenc:'+polyline"
                  :alt="bus.nombre"
                  class="img-fluid"
                >
              </div>
            </div>
          </div>
          <modal
            :foto="cover"
            @close-modal="modal=false"
            v-if="modal"
          />
          <div class="row mt-4">
            <h2 class="titulo-lugar-juarez">Galeria</h2>
          </div>
          <div class="row gallery-juarez">
            <div class="col">
              <slick
                ref="slick"
                :options="slickOptions"
              >
                <img
                  v-for="(item,key) in bus.metadata.gallery"
                  :key="key"
                  @click="showModal(item.url)"
                  :src="item.url"
                  alt="evento.nombre"
                  class="gallery-slides"
                />
              </slick>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
/* eslint-disable no-undef */
import http from '@/helpers/http'
import Overlay from '@/helpers/Overlay'
import slick from 'vue-slick'
import '../../../node_modules/slick-carousel/slick/slick.css'
// import '../../../node_modules/slick-carousel/slick/slick-theme.css'
import modal from './modal.vue'
const directionsService = new google.maps.DirectionsService()
export default {
  name: 'turibus',
  props: [],
  components: {
    Overlay,
    slick,
    modal
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // vm.reInit()
    })
  },
  data () {
    return {
      bus: {},
      puntos: [],
      cargando: true,
      modal: false,
      cover: null,
      slickOptions: {
        centerPadding: '60px',
        slidesToShow: 3
      },
      markers: '',
      polyline: ''
    }
  },
  computed: {

  },
  mounted () {
    this.getBus()
  },
  watch: {
    '$route.params': {
      immediate: true,
      deep: true,
      handler (value) {
        this.getBus()
      }
    },
    bus: {
      handler (value) {
        this.puntos = []
        value.metadata.puntos.map((punto, p) => {
          let cadena = ' '
          cadena = cadena.concat('. ', punto.titulo, ' | ', punto.data.formatted_address)
          this.puntos.push(cadena)
        })
      }
    }
  },
  methods: {
    getBus () {
      http.get('/turibus/' + this.$route.params.hash).then(res => {
        this.bus = res.data
        this.calculateAndDisplayRoute(res.data)
        this.cargando = false
      }, err => {
        console.log(err)
      })
    },
    reInit () {
      this.$nextTick(() => {
        this.$refs.slick.reSlick()
      })
    },
    showModal (foto) {
      this.cover = foto
      this.modal = true
    },
    calculateAndDisplayRoute (data) {
      let waypts = []
      let puntos = data.metadata.puntos
      puntos.map((el, i) => {
        waypts.push({
          location: { lat: el.ubicacion.lat, lng: el.ubicacion.lng },
          stopover: true
        })
        let color = '0x' + Math.floor(Math.random() * 16777215).toString(16)
        if (i === 0) color = 'green'
        if (i === puntos.length - 1) color = 'red'
        this.markers += '&markers=size:mid%7Ccolor:' + color + '%7Clabel:' + (i + 1) + '%7C' + el.ubicacion.lat + ',' + el.ubicacion.lng
      })
      let vm = this
      directionsService.route({
        origin: { lat: data.metadata.puntos[0].ubicacion.lat, lng: data.metadata.puntos[0].ubicacion.lng },
        destination: { lat: data.metadata.puntos[data.metadata.puntos.length - 1].ubicacion.lat, lng: data.metadata.puntos[data.metadata.puntos.length - 1].ubicacion.lng },
        waypoints: waypts,
        optimizeWaypoints: true,
        travelMode: 'DRIVING'
      }, function (response, status) {
        if (status === 'OK') {
          vm.polyline = response.routes[0].overview_polyline
          vm.cargando = false
        } else {
          vm.polyline = ''
          vm.cargando = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.bus {
  color: #5e5e5e;
  overflow: auto;
  height: 90vh;

  .imagen-banner {
    object-fit: cover;
    width: 100%;
    height: 25vh;
  }

  .titulo-lugar-juarez {
    color: #6f0f49;
    font-weight: bold;
  }

  .titulo-lugar-el-paso {
    color: #166073;
    font-weight: bold;
  }

  .titulo-lugar-las-cruces {
    color: #ee6225;
    font-weight: bold;
  }

  .texto-lugar {
    color: black;
    font-weight: bold;
    font-size: 1em;
  }

  .gallery-juarez {
    background-color: rgba($color: #6f0f49, $alpha: 0.7);
  }

  .gallery-el-paso {
    background-color: rgba($color: #166073, $alpha: 0.7);
  }

  .gallery-las-cruces {
    background-color: rgba($color: #ee6225, $alpha: 0.7);
  }

  .gallery-slides {
    object-fit: cover;
    height: 72px;
    width: 144px;
  }

  .mapa {
    text-align: center !important;
  }
}
</style>
